export default { sha: '234c9fdba655cdd551e5fe8cab0a1be8cb3efaba', buildNumber: 'undefined' }
